<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
  <span>{{ group?.name || "Grupo" }}</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="shareMyPosition()" aria-label="Compartir mi posición">
    <mat-icon>ios_share</mat-icon>
  </button>
</mat-toolbar>

@if (!loading && group) {
  <main class="group-page">
    <section class="group-hero">
      <div class="group-shield">
        @if (isShieldImage(group.shield)) {
          <img [src]="group.shield" [alt]="'Escudo de ' + group.name" />
        } @else {
          {{ group.shield || "🏆" }}
        }
      </div>
      <div>
        <h1>{{ group.name }}</h1>
        <p>{{ group.description || "La competición privada de este grupo." }}</p>
      </div>
    </section>

    @if (isAdmin) {
      <section class="group-card identity-form">
        <span class="section-kicker">Identidad del grupo</span>
        <label>Nombre <input [(ngModel)]="group.name" maxlength="80" /></label>
        <label>Escudo <input [(ngModel)]="group.shield" maxlength="500" placeholder="Emoji o URL" /></label>
        <label>Descripción <textarea [(ngModel)]="group.description" maxlength="500"></textarea></label>
        <button type="button" (click)="saveIdentity()" [disabled]="saving">Guardar identidad</button>
      </section>
    }

    <section class="group-stats">
      <div><strong>{{ stats.members }}</strong><span>Participantes</span></div>
      <div><strong>{{ stats.averagePoints }}</strong><span>Media de puntos</span></div>
      <div><strong>{{ stats.totalSnipers }}</strong><span>Dianas</span></div>
    </section>

    <span class="section-kicker">Podio semanal</span>
    <section class="weekly-podium">
      @for (entry of weeklyPodium; track entry.user._id; let i = $index) {
        <article>
          <span>{{ i === 0 ? "🥇" : i === 1 ? "🥈" : "🥉" }}</span>
          <app-avatar [user]="entry.user"></app-avatar>
          <strong>{{ entry.user.name }}</strong>
          <b>{{ entry.points }} pts</b>
        </article>
      }
      @if (weeklyPodium.length === 0) {
        <p>Aún no hay puntos en los últimos siete días.</p>
      }
    </section>

    <span class="section-kicker">Clasificación interna</span>
    <section class="group-card standings-list">
      @for (entry of standings; track entry.user._id; let i = $index) {
        <div [class.is-me]="entry.user._id === loggedUser?._id">
          <b>{{ i + 1 }}</b>
          <app-avatar [user]="entry.user"></app-avatar>
          <span>{{ entry.user.name }}</span>
          <strong>{{ entry.points }} pts</strong>
        </div>
      }
    </section>

    <span class="section-kicker">Muro del grupo</span>
    <section class="group-card wall">
      <div class="composer">
        <textarea [(ngModel)]="message" maxlength="500" placeholder="Escribe algo para el grupo..."></textarea>
        <button type="button" (click)="publish()" [disabled]="!message.trim() || saving">
          Publicar
        </button>
      </div>
      @for (post of posts; track post._id) {
        <article class="post">
          <app-avatar [user]="post.authorId"></app-avatar>
          <div>
            <strong>{{ post.authorId?.name }}</strong>
            <span>{{ post.createdAt | date: "d MMM, HH:mm" }}</span>
            <p>{{ post.message }}</p>
          </div>
        </article>
      }
      @if (posts.length === 0) {
        <p class="wall-empty">Sé la primera persona en publicar.</p>
      }
    </section>
  </main>
}
